$('.js-main-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 15000,
  pauseOnHover: true,
  cssEase: 'linear',
  arrows:false,
  dots: false
});

$('.Slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  cssEase: 'linear',
  arrows:true,
  dots: false,
  prevArrow:'<div class="slick_arrow slick_arrow-lft"><img width="30" height="30" src="https://cdn.shopify.com/s/files/1/0615/1628/4082/files/left-arrow.png?v=1652469452" /></div>',
  nextArrow:'<div class="slick_arrow slick_arrow-rt"><img width="30" height="30" src="https://cdn.shopify.com/s/files/1/0615/1628/4082/files/next.png?v=1652469453" /></div>', 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '60px',
          loop: false,
          arrows:false,
        }
      },
      {
        breakpoint: 480,
        settings: {
           slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '60px',
          loop: false,
          arrows:false,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]

});

$('.SlideLogo').slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  cssEase: 'linear',
  arrows:false,
  dots: true,
   responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]

});


AOS.init();



// ! Counter (used for Social Proof
$(function () {


    // CONFIG
    let visibilityIds = ['#counters_1', '#counters_template--16004097867954__165086212730c3e580', '#counters_template--16004097867954__1650864323a67f7ade', '#counters_hero','#counter_numb','#round-counter', '#counters-block-1', '#counters-block-2', '#counters-block-3', '#counters-block-4']; //must be an array, could have only one element
    let counterClass = '.counter';
    let defaultSpeed = 3000; //default value

    // END CONFIG

    //init if it becomes visible by scrolling
    $(window).on('scroll', function () {
        getVisibilityStatus();
    });

    //init if it's visible by page loading
    getVisibilityStatus();

    function getVisibilityStatus() {
        elValFromTop = [];
        var windowHeight = $(window).height(),
            windowScrollValFromTop = $(this).scrollTop();

        visibilityIds.forEach(function (item, index) { //Call each class
            try { //avoid error if class not exist
                elValFromTop[index] = Math.ceil($(item).offset().top);
            } catch (err) {
                return;
            }
            // if the sum of the window height and scroll distance from the top is greater than the target element's distance from the top, 
            //it should be in view and the event should fire, otherwise reverse any previously applied methods
            if ((windowHeight + windowScrollValFromTop) > elValFromTop[index]) {
                counter_init(item);
            }
        });
    }

    function counter_init(groupId) {
        let num, speed, direction, index = 0;
        $(counterClass).each(function () {
            num = $(this).attr('data-TargetNum');
            speed = $(this).attr('data-Speed');
            direction = $(this).attr('data-Direction');
            easing = $(this).attr('data-Easing');
            if (speed == undefined) speed = defaultSpeed;
            $(this).addClass('c_' + index); //add a class to recognize each counter
            doCount(num, index, speed, groupId, direction, easing);
            index++;
        });
    }

    function doCount(num, index, speed, groupClass, direction, easing) {
        let className = groupClass + ' ' + counterClass + '.' + 'c_' + index;
        if(easing == undefined) easing = "swing";
        $(className).animate({
            num
        }, {
            duration: +speed,
            easing: easing,
            step: function (now) {
                if (direction == 'reverse') {
                    $(this).text(num - Math.floor(now));
                } else {
                    $(this).text(Math.floor(now));
                }
            },
            complete: doCount
        });
    }
})

$(document).ready(function () {
  $('body').on('click', '.cus-desc-list li', function () {
    var name = $(this).data('name');
    if ($('#'+name).length) {
      $('html,body').animate({
       scrollTop: $('#'+name).offset().top
     }, 'slow');
    }
  });

   $(".click-event span").click(function(e){
    e.preventDefault();
    if ($(this).closest('li').hasClass('active')){
      $(".cus-desc-list li").removeClass("active");
      $(".cus-desc-list li .tab-content").slideUp(300);			
    } else {
      $(".cus-desc-list li").removeClass("active");
      $(this).closest('li').addClass('active'); 
      $(".cus-desc-list li .tab-content").slideUp(300);		
      $(".cus-desc-list li.active .tab-content").slideToggle(300);
    }
  });
  
})


// document.addEventListener('DOMContentLoaded', () => {
//   const observer = new MutationObserver(() => {
//     const shadowHost = document.querySelector('form-embed');
//     if (shadowHost && shadowHost.shadowRoot) {
//       const shadowRoot = shadowHost.shadowRoot;

//       const closeFormBtn = shadowRoot.querySelector('._formCloseButton_1684x_4');
//       const h = shadowRoot.querySelector('._textHeading_2aowh_35');
//       console.log("jjjjjjjjjjjjjjjjjpppppppppppppp", h);
//       h.style.color = 'red';
//       if (closeFormBtn) {
//         console.log('Close button found:', closeFormBtn);

//         closeFormBtn.addEventListener('click', (e) => {
//           e.stopImmediatePropagation();
//           e.preventDefault();
//           console.log('Close button clicked!');
//         });

//         observer.disconnect();
//       }
//     }
//   });

//   observer.observe(document.body, { childList: true, subtree: true });
// });


document.addEventListener('DOMContentLoaded', (event) => {
  const form = document.querySelector('[data-forms-id="forms-root-312058"]');
  form.classList.add('popup');
  const defaultInput = document.querySelector('.newsletter-form__field-wrapper .field input');

  if (form) {
    const closeButton = document.createElement("button");
    closeButton.classList.add("popup-close");
    closeButton.setAttribute("aria-label", "Close");
    closeButton.innerHTML = `
      <svg aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.41401 6.00012L11.707 1.70721C12.098 1.31622 12.098 0.684236 11.707 0.293244C11.316 -0.097748 10.684 -0.097748 10.293 0.293244L6.00001 4.58615L1.70701 0.293244C1.31601 -0.097748 0.684006 -0.097748 0.293006 0.293244C-0.0979941 0.684236 -0.0979941 1.31622 0.293006 1.70721L4.58601 6.00012L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.4141L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00012Z"></path>
      </svg>
    `;
    form.appendChild(closeButton);

    closeButton.addEventListener("click", () => {
      form.style.display = "none";
      defaultInput.disabled = false;
    });
  }

  const subscribeInput = document.querySelector('.newsletter-form__field-wrapper .field');
  subscribeInput.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    form.style.display = 'block';
    defaultInput.disabled = true;
  })
})
